import { CANCEL_GRUPO_CONTA_AGRARE_WHITE_LABEL_RAPIDO, CANCEL_GRUPO_CONTA_AGRARE_WHITE_LABEL_RAPIDO_SUCCESS } from '@handler';
import {
    NEW_GRUPO_CONTA_AGRARE_WHITE_LABEL_SUCCESS,
    TABLE_GRUPO_CONTA_AGRARE_WHITE_LABEL_PENDING,
    TABLE_GRUPO_CONTA_AGRARE_WHITE_LABEL_SUCCESS,
    TABLE_GRUPO_CONTA_AGRARE_WHITE_LABEL_FAILURE,
    FIND_GRUPO_CONTA_AGRARE_WHITE_LABEL_PENDING,
    FIND_GRUPO_CONTA_AGRARE_WHITE_LABEL_SUCCESS,
    FIND_GRUPO_CONTA_AGRARE_WHITE_LABEL_FAILURE,
    DELETE_GRUPO_CONTA_AGRARE_WHITE_LABEL_PENDING,
    DELETE_GRUPO_CONTA_AGRARE_WHITE_LABEL_SUCCESS,
    DELETE_GRUPO_CONTA_AGRARE_WHITE_LABEL_FAILURE,
    CREATE_GRUPO_CONTA_AGRARE_WHITE_LABEL_PENDING,
    CREATE_GRUPO_CONTA_AGRARE_WHITE_LABEL_SUCCESS,
    CREATE_GRUPO_CONTA_AGRARE_WHITE_LABEL_FAILURE,
} from './actionTypes';


const initialState = { list: null, loading: false }


function grupoContaAgrareWhiteLabelReducer(state = initialState, action) {

    switch (action.type) {
        case NEW_GRUPO_CONTA_AGRARE_WHITE_LABEL_SUCCESS:
            return {
                ...state,
                loading: false,
                registro: action.registro,
                isCadastroRapido: action.isCadastroRapido ?? false,
            }
        case FIND_GRUPO_CONTA_AGRARE_WHITE_LABEL_PENDING:
        case DELETE_GRUPO_CONTA_AGRARE_WHITE_LABEL_PENDING:
        case CREATE_GRUPO_CONTA_AGRARE_WHITE_LABEL_PENDING:
        case TABLE_GRUPO_CONTA_AGRARE_WHITE_LABEL_PENDING:
            return {
                ...state,
                loading: true,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CANCEL_GRUPO_CONTA_AGRARE_WHITE_LABEL_RAPIDO:
        case CANCEL_GRUPO_CONTA_AGRARE_WHITE_LABEL_RAPIDO_SUCCESS:
            return {
                ...state,
                isCadastroRapido: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case TABLE_GRUPO_CONTA_AGRARE_WHITE_LABEL_SUCCESS:
            return {
                ...state,
                table: action.table,
                loading: false
            }
        case TABLE_GRUPO_CONTA_AGRARE_WHITE_LABEL_FAILURE:
            return {
                ...state,
                table: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case FIND_GRUPO_CONTA_AGRARE_WHITE_LABEL_SUCCESS:
            return {
                ...state,
                registro: action.registro,
                loading: false
            }
        case FIND_GRUPO_CONTA_AGRARE_WHITE_LABEL_FAILURE:
            return {
                ...state,
                registro: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case DELETE_GRUPO_CONTA_AGRARE_WHITE_LABEL_SUCCESS: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CREATE_GRUPO_CONTA_AGRARE_WHITE_LABEL_SUCCESS:
        case CREATE_GRUPO_CONTA_AGRARE_WHITE_LABEL_FAILURE:
            return {
                ...state,
                loading: false,
                registro: action.registro,
                isCadastroRapido: false,
            }
        case DELETE_GRUPO_CONTA_AGRARE_WHITE_LABEL_FAILURE:
            return {
                ...state,
                loading: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        default:
            return state
    }
}

export { grupoContaAgrareWhiteLabelReducer };